export default [
    /**
	 * 通用路由
	*/
    {
        path: '/home',
        name: '首页',
        component: r => require.ensure([], () => r(require('@/views/home/index')), 'login')
    },
    {
        path: '/testing',
        name: '练习',
        component: r => require.ensure([], () => r(require('@/views/testing/index')), 'user')
    },
    {
        path: '/course',
        name: '课程',
        component: r => require.ensure([], () => r(require('@/views/course/index')), 'user')
    },
    {
        path: '/user',
        name: '个人中心',
        component: r => require.ensure([], () => r(require('@/views/user/index')), 'user')
    },
    {
        path: '/article',
        name: '文章详情',
        component: r => require.ensure([], () => r(require('@/views/common/article')), 'user')
    },
    {
        path: '/buy/index',
        name: '购买课时',
        component: r => require.ensure([], () => r(require('@/views/buy/index')), 'user')
    },
    {
        path: '/buy/code',
        name: '学时码兑换',
        component: r => require.ensure([], () => r(require('@/views/buy/code')), 'user')
    },
    {
        path: '/train',
        name: '声、韵、调发音训练',
        component: r => require.ensure([], () => r(require('@/views/train/index')), 'user')
    },
    {
        path: '/404',
        name: '404',
        component: r => require.ensure([], () => r(require('@/views/common/404')), 'user')
    },
    {
        path: '/author',
        name: '登录授权',
        component: r => require.ensure([], () => r(require('@/views/common/author')), 'user')
    },
    {
        path: '/notice',
        name: '报名通知',
        component: r => require.ensure([], () => r(require('@/views/common/notice')), 'user')
    }
]



// WEBPACK FOOTER //
// ./src/router/routers/public.js